import type { Language } from '@shefira/shared';

import { language, setLanguage } from '../i18n/language.js';
import { iconButton } from './hud.js';

/**
 * The language switch of the welcome screens (ADR 0069): the other
 * language's pixel flag (`icon-flag-<lang>.png`, drawn by
 * `scripts/draw-flags.py`), named in that language (« English » on a French
 * screen), so a player who cannot read the current one still finds the way
 * out. In play the same choice sits in the settings, under Affichage.
 */
export const LANGUAGE_NAMES: Record<Language, string> = { fr: 'Francais', en: 'English' };

export function languageButton(): HTMLButtonElement {
  const other: Language = language() === 'fr' ? 'en' : 'fr';
  // The name is shown as is: each language is named in itself, never translated.
  const button = iconButton(`flag-${other}`, '');
  button.classList.add('hud-button--language');
  button.title = LANGUAGE_NAMES[other];
  button.setAttribute('aria-label', LANGUAGE_NAMES[other]);
  button.lang = other;
  button.addEventListener('click', () => {
    setLanguage(other);
  });
  return button;
}

/** A language's flag, small, before its name (the settings row). */
export function languageFlag(which: Language): HTMLSpanElement {
  const flag = document.createElement('span');
  flag.className = 'language-flag';
  flag.style.backgroundImage = `url('/assets/ui/icon-flag-${which}.png')`;
  flag.setAttribute('aria-hidden', 'true');
  return flag;
}
